import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import AnswerWrapper from "../../Partials/AnswerWrapper";
import CuitForm from "../CuitForm/index";
import AgregarAdherentes from "../AgregarAdherentes/index";
import Response from "../Response/index";
import { sendEmailGuide } from "../../../../apis";
import { enterprises } from "../../../../actions/listEnterprises";
class Question extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      token: localStorage.getItem("token"),
    };
  }

  componentWillMount() {
    document.title = "Gestorando";
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.questionData !== nextProps.questionData) {
      return true;
    }
    if (this.props.questions !== nextProps.questions) {
      return true;
    }
    if (this.state.token !== nextState.token) {
      return true;
    }
    return false;
  }

  renderBackButton() {
    if (this.props.showBackButton) {
      return (
        <button
          className="btn-back"
          type="button"
          onClick={this.props.onBackQuestion}
        >
          <i className="fas fa-chevron-left" />
          Volver
        </button>
      );
    }

    return null;
  }

  renderNextButton() {
    const question = this.props.questionData;
    const buttonText =
      "nextButtonText" in question ? question.nextButtonText : "Siguiente";

    if (this.props.showNextButton) {
      let buttonIsDisabled;

      // Checking if has posible answers
      if (question.posibleAnswers) {
        if (
          question.type === "multipleChoice" ||
          question.type === "uniqueChoice"
        ) {
          buttonIsDisabled =
            question.posibleAnswers.filter((answer) => answer.selected === true)
              .length === 0;
        } else {
          buttonIsDisabled = false;
        }
      }

      return (
        <button
          className={`
              ${buttonIsDisabled ? false : "remove-disable"} btn-next`}
          type="button"
          onClick={this.props.onNextQuestion}
          disabled={buttonIsDisabled}
        >
          {buttonText}
          <i className="fas fa-chevron-right" />
        </button>
      );
    }

    return null;
  }

  async sendEmailGuide(code) {
    try {
      const form = { code };
      await sendEmailGuide(form);
    } catch (error) {}
  }

  renderQuestion() {
    const question = this.props.questionData;
    const { questions } = this.props;
    const enterprise = localStorage.getItem("enterprise");

    /* Agregar Adherentes Component (id: 4) */
    if (enterprises.includes(enterprise) && question.id === 8) {
      return (
        <AgregarAdherentes
          title={question.title}
          description={question.description}
          onBackQuestion={this.props.onBackQuestion}
          onNextQuestion={this.props.onNextQuestion}
        />
      );
    }

    if (question.id === 4 && !enterprises.includes(enterprise)) {
      return (
        <AgregarAdherentes
          title={question.title}
          description={question.description}
          onBackQuestion={this.props.onBackQuestion}
          onNextQuestion={this.props.onNextQuestion}
        />
      );
    }

    // If payment was success from Credit/Debit card then trigger to Analytics
    if (question.id === 8) {
      window.dataLayer.push({
        event: "transaccion",
        value: localStorage.getItem("price"),
      });

      return (
        <div className="questions" key={question.id}>
          <Response question={question} questions={questions} />
          <AnswerWrapper question={question} questions={questions} />
          <div className="btns-next-back-wrapper">
            {this.renderBackButton()}
            {this.renderNextButton()}
          </div>
        </div>
      );
    }

    /* CuitForm Component (id: 11) */
    if (question.id === 11) {
      return (
        <CuitForm
          question={question}
          onBackQuestion={this.props.onBackQuestion}
        />
      );
    }

    /* Beat CuitForm Component (id: 2) */
    if (question.id === 2 && enterprises.includes(enterprise)) {
      return (
        <CuitForm
          question={question}
          onBackQuestion={this.props.onBackQuestion}
        />
      );
    }

    /* Enviar email de guia para sacar CUIT y clave fiscal por internet (id: 14) */
    if (question.id === 14) {
      this.sendEmailGuide("T");
    }

    /* Enviar email de guia para sacar CUIT y clave fiscal presencial (id: 14.1) */
    if (question.id === 14.1) {
      this.sendEmailGuide("O");
    }
    return (
      <div className="questions" key={question.id}>
        <Response question={question} questions={questions} />
        <AnswerWrapper question={question} questions={questions} />
        <div className="btns-next-back-wrapper">
          {this.renderBackButton()}
          {this.renderNextButton()}
        </div>
      </div>
    );
  }

  render() {
    return this.renderQuestion();
  }
}

Question.propTypes = {
  questions: PropTypes.array,
  questionData: PropTypes.object,
  onNextQuestion: PropTypes.func,
  onBackQuestion: PropTypes.func,
  showNextButton: PropTypes.bool,
  showBackButton: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    questions: state.empresasQuestionnaire,
  };
}

export default connect(mapStateToProps)(Question);
